module.exports = __webpack_public_path__ + "images/icon/triangle_left_black-ea867cc5.svg";